import { Injectable } from '@angular/core';
import { TokenRequest } from '../shared/models/tokenrequest.model';
import { ConfigService } from '../shared/services/configService';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import { EnvironmentSettings } from '../shared/models/environmentsettings.model';
import { writeFileAsync } from 'xlsx';

@Injectable()
export class AuthService {
  appConfig: any;
  appToken: string;
  isAdminUser = false;
  tokenRequest: TokenRequest;
  environmentSettings: EnvironmentSettings;
  constructor(private _configService: ConfigService, private _userService: UserService, private _router: Router) {
    this.environmentSettings = new EnvironmentSettings();
  }

  isAuthenticated() {
    return (this.appToken != null);
  }

  getAppConfig() {
    this.appConfig = this._configService.config ? this._configService.config : {};
    if (this.appConfig) {
      this.appToken = this.appConfig.token;
      let config: any;
      if (localStorage.getItem('app_token') != null) {
        config = JSON.parse(localStorage.getItem('app_token'));
        this.isAdminUser = config.isAdmin == 'true' ? true : false;
      }
    }
    return this.appConfig;
  }
  singinUser() {
  }
  signIn(tokenRequest: TokenRequest) {
    this._userService.validateAdminUser(tokenRequest).subscribe(
      (res: any) => {
        this.appConfig = this._configService._config = res;
        localStorage.removeItem('app_token');
        localStorage.setItem('app_token', JSON.stringify(res));
        this.isAdminUser = this.appConfig ? this.appConfig.isAdmin : false;
        if (this.appConfig) {
          this.appToken = this.appConfig.token;
        }
        this._router.navigate(['']);
      }
    );
  }
  logout() {
    localStorage.removeItem('app_token');
    this._configService._config = null;
    this.appConfig = null;
  }
}



// WEBPACK FOOTER //
// ./src/opc/auth/auth-service.ts